import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, getDateInStringDDMMMYYYY, isEmpty, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import Grid from '@material-ui/core/Grid';
import AssignmentIcon from '@material-ui/icons/Assignment';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import {
  SimTracking,
  AddExpense,
  AddCharge,
  AddAdvance,
  AddPayment,
  OnlineBilty
} from '../Icons/TripActionsIcon';
import DescriptionIcon from '@material-ui/icons/Description';
import PaymentIcon from '@material-ui/icons/Payment';
import Payment from '@material-ui/icons/Payment';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import PostAddIcon from '@material-ui/icons/PostAdd';
import TripActionDialog from './TripActionDialog';
import ComingSoonModal from '../ComingSoonModal/comingSoonModal';
import { trackDwebEvent } from '../../analytics';
// import SimTrackingDialog from '../../pages/SimTracking/SimTracking';
// import CheckApprovalDialog from '../../pages/SimTracking/CheckApproval';
import { getTripDetailsV3, loadElr, getElrInfo } from '../../../store/actions/tripActionCreator';
import { getTripLedgerData,getTripLedgerDataV2 } from '../../../store/actions/homeActionCreator';
import MapComponent from '../MapComponent/MapComponent';
import BiltyHome from '../../pages/Bilty/BiltyHome';
import BiltyHomeSteps from '../../pages/Bilty/BiltyHomeSteps';
import BiltyFlow from '../../pages/Bilty/BiltyFlow/BiltyFlow';
import BiltyPopUp from '../Dialog/BiltyPopUp';
import FreeTrialAlertsDialog from '../Dialog/FreeTrialAlertsDialog';
import * as logger from '../../../logger';
import SimTrackingPopUp from '../Dialog/SimTrackingPopUp';
import { defaultPageNo,defaultPageSize } from '../../../paginationVariables';
const useStyles = makeStyles((theme) => ({
  info: {
    padding: '8px 25px',
    backgroundColor: '#ebebf1',
    height: '100%',
    minHeight: 113,
    maxHeight: 113,
    borderRadius: 8,
    fontWeight: 300
  },
  actionPaper: {
    width: 64,
    height: 64,
    padding: 12,
    borderRadius: 8,
    boxShadow: 'none',
    cursor: 'pointer',
    margin: 'auto',
    '&:hover': {
      border: '1px solid #0033cc'
    }
  },
  actionLabel: {
    fontSize: 12,
    fontWeight: 600,
    margin: '4px 0px',
    color: '#161f34',
    textAlign: 'center'
  },
  actionLabelDiv: {
    height: '100%',
    minHeight: 28,
    maxHeight: 28,
  },
  onlineBilty: {
    fontSize: 40,
    color: '#6b778c'
  },
  simTracking: {
    fontSize: 40,
    color: '#FFBE00'
  },
  addExpense: {
    fontSize: 40,
    color: '#d71e1d'
  },
  addCharges: {
    fontSize: 40,
    color: '#0033cc'
  },
  addAdvance: {
    fontSize: 40,
    color: '#008556'
  },
  addPayment: {
    fontSize: 40,
    color: '#6200ee'
  },
  iconGrid: {
    padding: 0
  }
}));

const TripActionsCard = (props) => {
  const { location, user, onActionEnd, dispatchTripDetailsAction, dispatchLoadElr, dispatchGetElrInfo, dispatchGetTripLedgerAction, payments, open, trip } = props;
  let history = useHistory();
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripDetails = user.singleTripData ? user.singleTripData : {};
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : path[path.length - 1];
  let vehicleData = tripDetails && tripDetails.vehicle ? tripDetails.vehicle : {};
  let hiredTrip = tripDetails && tripDetails.vehicle && tripDetails.vehicle.ownershipType && tripDetails.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorId = hiredTrip && tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : 0;
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let partyBalance = tripDetails && tripDetails.partyBalance ? tripDetails.partyBalance : null;
  let vendorBalance = tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : null;
  let vendorSettled = tripDetails && !isEmpty(tripDetails.isVendorSettled) ? tripDetails.isVendorSettled : tripDetails && tripDetails.vendorBalance && Number(tripDetails.vendorBalance) == 0 ? true : false;
  let actionVisible = () => {
    if (hiredTrip) {
      return (tripStatus == 'PAYMENT_RECEIVED' && vendorSettled) ? false : true
    } else {
      return (tripStatus == 'PAYMENT_RECEIVED') ? false : true
    }
  }

  const elrId = user && user.singleTripData && user.singleTripData.elr_id ? user.singleTripData.elr_id : ""

  const classes = useStyles();

  const trackTransactions = (name, id) => {
    trackDwebEvent(name, {
      trip_id: tripId,
      party_id: user && user.singleTripData && user.singleTripData.party && user.singleTripData.party.customerId?user.singleTripData.party.customerId:'',
      party_name: user && user.singleTripData && user.singleTripData.party && user.singleTripData.party.name?user.singleTripData.party.name:'',
      vehicle_id: user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.id?user.singleTripData.vehicle.id:'',
      vehicle_number: user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.number?user.singleTripData.vehicle.number:'',
      trip_status: user && user.singleTripData && user.singleTripData.status?user.singleTripData.status:'',
      vendor_id: id ? id : null
    });
  }
  const tripActions = [
    {
      icon: <AddExpense className={classes.addExpense} />,
      visible: true,
      action: 'add_expense',
      label: 'Add Expense',
      tabsFormat: false,
      eventName: 'Dweb Trip Expense Create Initiated'
    },
    {
      icon: <AddCharge className={classes.addCharges} />,
      action: 'add_charges',
      visible: actionVisible(),
      label: 'Add Charges',
      tabsFormat: true,
      eventName: 'Dweb Trip Charge Create Initiated',
      tabs: [
        {
          name: 'Party Charge',
          visible: true,
          disabled: tripStatus == 'PAYMENT_RECEIVED' ? true : false,
          person: 'party'
        },
        {
          person: 'supplier',
          disabled: vendorSettled,
          visible: hiredTrip,
          name: 'Supplier Charge'
        }
      ]
    },
    {
      icon: <AddAdvance className={classes.addAdvance} />,
      action: 'add_advance',
      visible: actionVisible(),
      label: 'Add Advance',
      tabsFormat: true,
      eventName: 'Dweb Trip Advance Create Initiated',
      tabs: [
        {
          name: 'Party Advance',
          visible: true,
          disabled: tripStatus == 'PAYMENT_RECEIVED' ? true : false,
          person: 'party'
        },
        {
          person: 'supplier',
          visible: hiredTrip,
          disabled: vendorSettled,
          name: 'Supplier Advance'
        }
      ]
    },
    {
      icon: <AddPayment className={classes.addPayment} />,
      action: 'add_payment',
      label: 'Add Payment',
      visible: actionVisible(),
      eventName: 'Dweb Trip Advance Payment Initiated',
      tabsFormat: true,
      tabs: [
        {
          name: 'Party Payment',
          visible: true,
          disabled: tripStatus == 'PAYMENT_RECEIVED' ? true : false,
          person: 'party'
        },
        {
          person: 'supplier',
          visible: hiredTrip,
          disabled: vendorSettled,
          name: 'Supplier Payment'
        }
      ]
    },
    {
      icon: <SimTracking className={classes.simTracking} />,
      action: 'sim_tracking',
      visible: vehicleData.tracking_status == "completed" && vehicleData.location_points && vehicleData.location_points.length == 0 ? false : true,
      label: 'Sim Tracking'
    },
    {
      icon: <OnlineBilty className={classes.onlineBilty} />,
      action: 'online_bilty',
      visible: true,
      label: 'Online Bilty'
    }]
  const [addTripActionOpen, setAddTripActionOpen] = useState(false);
  const [action, setAction] = useState(null);
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const [simTrackingDialogOpen, setSimTrackingDialogOpen] = useState(false);
  const [simTrackingCheckApproval, setSimTrackingCheckApproval] = useState(false);
  const [staticStatus, setStaticStatus] = useState(false);
  const [consentPending, setConsentPending] = useState(false);
  const [locationPolling, setLocationPolling] = useState(false);
  const [biltyOpen, setBiltyOpen] = useState(false);
  const [biltyStepsOpen, setBiltyStepsOpen] = useState(false);
  const [biltyFlowOpen, setBiltyFlowOpen] = useState(false);
  const [pdfPreview, setPdfPreview] = useState(false);
  const [biltyTimeline, setBiltyTimeline] = useState(false);
  const [biltyPopUp, setBiltyPopUp] = useState(false);
  const [freeTrailOpen, setFreeTrailOpen] = useState(false);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    if (user && user.userInfo && user.userInfo.role) {
      setUserRole(user.userInfo.role);
    }
  }, [user.userInfo]);


  useEffect(() => {

    let premEnabled = user && user.configs && user.configs.subscription && user.configs.subscription.enabled && user.configs.subscription.enabled == 1 ? true : false;

    const checkSimPopUp = localStorage.getItem('BiltyPopUpShown');

    if (!payments.shownFreeTrail || !checkSimPopUp) {
      const tripLedgerRequestData = {
        fleetOwnerId: user.userInfo.entityId,
        pageNo: defaultPageNo,
        pageSize: defaultPageSize
      };

      dispatchGetTripLedgerAction({
        ...tripLedgerRequestData
      },
        (data) => {
          if (data && data.status && data.status.code == 200) {
            if (data && data.response && data.response.totalCount == 2 && !payments.shownFreeTrail) {
              if (premEnabled) {
                if (payments && payments.freeTrial && payments.freeTrial === true) {
                  setTimeout(() => {
                    if (location && (!location.state || !location.state.pageTitle || (location.state.pageTitle && location.state.pageTitle != "Premium"))) {
                      setFreeTrailOpen(true);
                    }
                  }, 5000)
                }
              }
              // dispatchUpdateModal(true);
            } else {
              setFreeTrailOpen(false);
              // dispatchUpdateModal(false);
            }

            if (data && data.response && data.response.totalCount != 2 && data.response.totalCount != 0 && !checkSimPopUp) {
              setBiltyPopUp(true);
            } else {
              setBiltyPopUp(false);
            }
          }
        },
        () => {

        }
      );
    }

  }, [open]);


  const handleComingSoonOpen = () => {
    setComingSoonOpen(true);
  }

  const handleComingSoonClose = () => {
    setComingSoonOpen(false);
  }

  const handleActionClick = (action) => {
    trip.elrInfo = {};
    trip.congineePdf = {};
    trip.consignorPdf = {};
    setAction(action);
    if (action && action.action == 'online_bilty') {
      // handleComingSoonOpen();
      let checkAllTrue = false;
      if (user && user.singleTripData && user.singleTripData.elr_status) {
        checkAllTrue = Object.keys(user.singleTripData.elr_status).every(k => user.singleTripData.elr_status[k]);
      }

      dispatchLoadElr(
        tripId,
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('Bilty Home Dweb', "Load Elr Successfull");
            if (elrId) {
              dispatchGetElrInfo(elrId,
                (data) => {
                  if (data && data.status && data.status.code == 200) {
                    logger.log('Bilty Home Dweb', 'Get ELR info successfull');
                    dispatchTripDetailsAction(tripId, (data) => {
                      if (data && data.status && data.status.code == 200) {
                        if (checkAllTrue) {
                          setPdfPreview(true);
                          setBiltyFlowOpen(true);
                        } else {
                          setBiltyStepsOpen(true);
                        }
                      }
                    },
                      () => {

                      }
                    );
                  }
                },
                () => {
                  logger.log('Bilty Home Dweb', 'Get ELR info failed');
                }
              )
            } else {
              setBiltyStepsOpen(true);
            }
          }
        },
        () => {
          logger.log('Bilty Home Dweb', "Load Elr Failed");
        }
      )

    } else if (action && action.action == 'sim_tracking') {

      dispatchTripDetailsAction(tripId,
        (data) => {
          if (data && data.status && data.status.code == 200) {

            if (data.response && data.response.vehicle && !data.response.vehicle.tracking_status) {
              setSimTrackingDialogOpen(true);
              setSimTrackingCheckApproval(false);
            } else if (data.response && data.response.vehicle && data.response.vehicle.tracking_status == "consent_pending") {
              setSimTrackingCheckApproval(true);
              setConsentPending(true);
              setSimTrackingDialogOpen(false);
              setStaticStatus(false);
              setLocationPolling(false);
            } else if (data.response && data.response.vehicle && data.response.vehicle.tracking_status == "static") {
              setSimTrackingCheckApproval(true);
              setStaticStatus(true);
              setConsentPending(false);
              setSimTrackingDialogOpen(false);
              setLocationPolling(false);
            } else if (data.response && data.response.vehicle && data.response.vehicle.tracking_status == "location_polling") {
              setStaticStatus(false);
              setConsentPending(false);
              setSimTrackingDialogOpen(false);
              if (data.response && data.response.vehicle && data.response.vehicle.location_points && data.response.vehicle.location_points.length == 0) {
                setSimTrackingCheckApproval(true);
                setLocationPolling(true);
              } else if (data.response && data.response.vehicle && data.response.vehicle.location_points && data.response.vehicle.location_points.length > 0) {
                setSimTrackingCheckApproval(false);
                setLocationPolling(false);
                history.push({
                  pathname: `/trips/sim-tracking-map/${tripId}`,
                  // component: MapComponent,
                  state: {
                    id: 1,
                    pageTitle: data.response && data.response.vehicle && data.response.vehicle.driverName ? data.response.vehicle.driverName : "",
                    sourceLocation: data.response && data.response.startLocation ? data.response.startLocation : "",
                    destinationLocation: data.response && data.response.destinationLocation ? data.response && data.response.destinationLocation : ""
                  }
                })
              }
            } else if (data.response && data.response.vehicle && data.response.vehicle.tracking_status == "completed") {
              if (data.response && data.response.vehicle && data.response.vehicle.location_points && data.response.vehicle.location_points.length > 0) {
                setStaticStatus(false);
                setConsentPending(false);
                setSimTrackingDialogOpen(false);
                setSimTrackingCheckApproval(false);
                setLocationPolling(false);
                history.push({
                  pathname: `/trips/sim-tracking-map/${tripId}`,
                  // component: MapComponent,
                  state: {
                    id: 1,
                    pageTitle: data.response && data.response.vehicle && data.response.vehicle.driverName ? data.response.vehicle.driverName : "",
                    sourceLocation: data.response && data.response.startLocation ? data.response.startLocation : "",
                    destinationLocation: data.response && data.response.destinationLocation ? data.response && data.response.destinationLocation : ""
                  }
                })
              }
            }
          }
        },
        () => {

        });

    } else {
      trackTransactions(action.eventName ? action.eventName : '')
      setAddTripActionOpen(true);
    }

    if (action.action == "add_payment") {
      trackDwebEvent("Dweb Party Payment Initiated", {
        party_id: tripDetails && tripDetails.party && tripDetails.party.id ? tripDetails.party.id : "",
        party_name: tripDetails && tripDetails.partyName ? tripDetails.partyName : "",
        party_balance: tripDetails && tripDetails.partyBalance ? tripDetails.partyBalance : "",
      });
    }
  }
  const handleaddTripActionClose = (status) => {
    setAddTripActionOpen(status);
    onActionEnd();
  }
  const handleSimTrackingDialogClose = () => {
    setSimTrackingDialogOpen(false);
  }
  const handleConsentPendingClose = () => {
    setSimTrackingCheckApproval(false);
  }
  const handleActionSave = (status) => {

  }

  // const handleBiltyHomeClose = () => {
  //   setBiltyOpen(false);
  // }

  // const handleBiltyHomeNext = () => {
  //   setBiltyOpen(false);
  //   setTimeout(() => {
  //     setBiltyStepsOpen(true);
  //   }, 70);
  // }

  const handleBiltyStepsClose = () => {
    setBiltyStepsOpen(false);
  }

  const handleCreateBilty = () => {


    setBiltyStepsOpen(false);

    if (user && user.singleTripData && user.singleTripData.elr_status) {
      const checkAllTrue = Object.keys(user.singleTripData.elr_status).every(k => user.singleTripData.elr_status[k]);
      const checkAllFalse = Object.keys(user.singleTripData.elr_status).every(k => !user.singleTripData.elr_status[k]);
      const checkAnyFalse = Object.keys(user.singleTripData.elr_status).some(k => !user.singleTripData.elr_status[k]);

      if (!checkAllTrue) {
        setPdfPreview(false)
      }

      setTimeout(() => {
        setBiltyFlowOpen(true);
      }, 110)

      if (checkAllFalse) {
        setBiltyTimeline(false);
      } else if (checkAnyFalse) {
        setBiltyTimeline(true);
      }

    } else {
      setTimeout(() => {
        setBiltyFlowOpen(true);
      }, 110)
    }

  }

  const handleBiltyFlowClose = () => {
    setBiltyFlowOpen(false);
  }

  const handleBiltyPopUpClose = () => {
    setBiltyPopUp(false);
  }

  const goToBilty = () => {
    setBiltyPopUp(false);
    handleActionClick(
      { action: "online_bilty" }
    );
  }

  const handleFreeTrialClose = (status) => {
    setFreeTrailOpen(false);
  };

  const handleFreeTrialConfirm = (status) => {
    setFreeTrailOpen(false);
    goToPremium();
  };

  const goToPremium = (data) => {
    history.push({
      pathname: `/payments`,
      state: {
        id: 1,
        pageTitle: 'Premium'
      }
    });
  }


  const handleBiltyCompanyDetailsContinue = () => {

  }

  return (
    <Paper className={classes.info}>
      <Grid container spacing={3} direction="row" justify="center" alignItems="center">
        {tripDetails && tripActions.map((action) => action.visible ? (
          <Grid item xs={2} className={classes.iconGrid}>
            <Paper className={classes.actionPaper} onClick={(e) => handleActionClick(action)}>
              {action.icon}
            </Paper>
            <div className={classes.actionLabelDiv}>
              <Typography className={classes.actionLabel}>{action.label}</Typography>
            </div>
          </Grid>
        ) : null)}
      </Grid>
      {addTripActionOpen && <TripActionDialog action={action} partyBalance={partyBalance} vendorBalance={vendorBalance} open={addTripActionOpen} onClose={handleaddTripActionClose} onSave={handleActionSave} />}
      {comingSoonOpen && <ComingSoonModal open={comingSoonOpen} featureName={action.label} onClose={handleComingSoonClose} />}

      {/* **********************************************Sim tracking Side bars *********************************** */}
      {/* {simTrackingDialogOpen && <SimTrackingDialog open={simTrackingDialogOpen} onClose={handleSimTrackingDialogClose} />}
      {simTrackingCheckApproval && <CheckApprovalDialog open={simTrackingCheckApproval} onClose={handleConsentPendingClose} staticValue={staticStatus} consentPendingValue={consentPending} locationPollingValue={locationPolling} />} */}

      {/* ************************************************Bilty Side bars*********************************************** */}
      {/* {biltyOpen && <BiltyHome open={biltyOpen} onClose={handleBiltyHomeClose} onNext={handleBiltyHomeNext} tripIdValue={tripId} />} */}
      {biltyStepsOpen && <BiltyHomeSteps open={biltyStepsOpen} onClose={handleBiltyStepsClose} onCreateBilty={handleCreateBilty} />}
      {biltyFlowOpen && <BiltyFlow open={biltyFlowOpen} onClose={handleBiltyFlowClose} biltyTimeLineValue={biltyTimeline} pdfPreviewValue={pdfPreview} />}
      {biltyPopUp && <BiltyPopUp open={biltyPopUp} onClose={handleBiltyPopUpClose} onBilty={goToBilty} />}

      {/* ************************************************************Free Trail**************************************************. */}
      {freeTrailOpen && userRole != "USER" && <FreeTrialAlertsDialog confirmOpen={freeTrailOpen} status={payments.subscriptionStatus} onClose={handleFreeTrialClose} onConfirm={handleFreeTrialConfirm} />}

    </Paper>
  );
}
const TripActionsCardWithRouter = withRouter(TripActionsCard);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) => {
    dispatch(getTripDetailsV3(tripId, onSuccess, onError))
  },
  dispatchLoadElr: (tripId, onSuccess, onFailure) => {
    dispatch(loadElr(tripId, onSuccess, onFailure))
  },
  dispatchGetElrInfo: (elrId, onSuccess, onError) => {
    dispatch(getElrInfo(elrId, onSuccess, onError))
  },
  dispatchGetTripLedgerAction: (requestData, onSuccess, onFailure) =>
    dispatch(
      getTripLedgerDataV2(
        requestData, onSuccess, onFailure
      )
    ),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripActionsCardWithRouter);